module.exports = __webpack_public_path__ + "static/media/APP_EarlyRiser_152x174_6.d27d4ce1.png";